import React from 'react';
import Icon from '../../../components/AppIcon';

const WelcomeHeader = ({ userName = "John Doe" }) => {
  const getCurrentGreeting = () => {
    const hour = new Date()?.getHours();
    if (hour < 12) return "Good morning";
    if (hour < 17) return "Good afternoon";
    return "Good evening";
  };

  const getCurrentDate = () => {
    const now = new Date();
    return now?.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div className="relative">
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <div className="flex items-center space-x-4 mb-4">
            <div className="w-16 h-16 bg-gradient-to-br from-accent to-accent/70 rounded-full flex items-center justify-center shadow-lg border-2 border-accent/30">
              <Icon name="Gem" size={28} color="var(--color-accent-foreground)" />
            </div>
            <div>
              <h1 className="text-3xl font-heading text-foreground bg-gradient-to-r from-foreground to-foreground/80 bg-clip-text">
                {getCurrentGreeting()}, {userName}
              </h1>
              <p className="text-muted-foreground font-medium">{getCurrentDate()}</p>
            </div>
          </div>
          <p className="text-foreground font-medium">
            Welcome to your design collaboration dashboard. Manage projects, review feedback, and collaborate with your team.
          </p>
        </div>
        
        <div className="hidden lg:flex items-center space-x-6">
          <div className="text-right">
            <div className="flex items-center space-x-2 text-sm text-muted-foreground mb-2">
              <div className="w-6 h-6 bg-success/20 rounded-full flex items-center justify-center">
                <Icon name="Clock" size={12} className="text-success" />
              </div>
              <span className="font-medium">Last login: Today, 9:30 AM</span>
            </div>
            <div className="flex items-center space-x-2 text-sm text-muted-foreground">
              <div className="w-6 h-6 bg-success/20 rounded-full flex items-center justify-center">
                <Icon name="Shield" size={12} className="text-success" />
              </div>
              <span className="font-medium">All systems secure</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeHeader;